<template>
  <div class="cloud-intercom-page">
    <div class="ci-body ci-body--center">
      <h1 class="ci-body__title text-left">
        {{ $t('Intercom.CloudIntercom.Common.Welcome') }}
      </h1>
      <p class="ci-body__subtitle">
        {{ communityName ? $t('Intercom.CloudIntercom.Common.CommunityIntercom', { name: communityName }) : $t('Intercom.CloudIntercom.Common.ProductName') }}
      </p>
      <img
        class="ci-body__illustration"
        src="@/assets/img/intercom/cloud-intercom-no-contract.webp"
        alt=""
      >
      <p class="ci-body__message">
        {{ $t('Intercom.CloudIntercom.BlockingPage.NoContract') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockingPage',
  props: {
    communityName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import './cloudIntercom';

.ci-body__subtitle {
  width: 100%;
  text-align: left;
}
</style>
